import { Link } from "@inertiajs/react";
import { SearchX } from "lucide-react";

export default function CapsEmptyState() {
  return (
    <div className="rounded-[2rem] border border-border bg-neutral-100/30 px-6 py-20 text-center">
      <div className="mx-auto flex size-16 items-center justify-center rounded-full bg-white shadow-lg">
        <SearchX className="size-7" />
      </div>

      <h2 className="mt-6 text-3xl font-black uppercase tracking-tight">
        No caps found
      </h2>

      <p className="mx-auto mt-3 max-w-md text-sm leading-7 text-muted-foreground">
        No products currently match this filter. Explore the complete collection
        or choose a different filter.
      </p>

      <Link
        href="/all-caps"
        className="mt-8 inline-flex min-h-12 items-center justify-center rounded-full bg-neutral-950 px-6 py-3 text-sm font-black uppercase text-white"
      >
        View All Caps
      </Link>
    </div>
  );
}